import useAnalytics from "@/hooks/useAnalytics";
import useTranslation from "@/hooks/useTranslation";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { message, Popconfirm, Tooltip } from "antd";
import { ReactNode } from "react";
import { useBulkPatchPackagingMaterial } from "../usePackagingMaterials";

export default function DeleteMaterialImpactReferenceAction({
  materialIds,
  onSuccess,
  children,
}: {
  materialIds: number[];
  onSuccess?: () => void;
  children: ReactNode;
}) {
  const translation = useTranslation();
  const bulkPatch = useBulkPatchPackagingMaterial();
  const analytics = useAnalytics();

  const onDelete = () =>
    bulkPatch
      .mutateAsync({
        materialIds,
        patch: {
          clear: ["impact_dataset_id"],
        },
      })
      .then(() => {
        message.success(`Impact reference${materialIds.length === 1 ? "" : "s"} deleted.`);
        analytics.track("Packaging Material Reference Deleted");
        onSuccess?.();
      })
      .catch(() => {
        message.error(translation.errors.general);
      });

  const materialLabel = materialIds.length === 1 ? "material" : `${materialIds.length} materials`;
  const title = `Delete material impact reference for ${materialLabel}`;
  const okText = `Delete ${materialLabel}`;

  return (
    <Popconfirm
      title={title}
      description={
        <>
          <p>
            Deleting the impact reference for a material means it will no longer be included in the
            impact calculation.
          </p>
          <p style={{ color: "#F5222D" }}>This action can not be undone.</p>
        </>
      }
      onConfirm={onDelete}
      icon={<ExclamationCircleFilled style={{ color: "#F5222D" }} />}
      okText={okText}
      cancelText={"Cancel"}
      placement="bottom"
      okType="danger"
      okButtonProps={{ loading: bulkPatch.isLoading }}
    >
      <Tooltip
        placement="top"
        title={"Delete impact reference"}
      >
        {children}
      </Tooltip>
    </Popconfirm>
  );
}
